<template>
  <CustomCreateDialog
    dialogTitle="ایجاد تنظیمات جدید"
    dialogId="create-match-setting-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendCreateMatchSettingRequest"
  >
    <BCol cols="12">
      <TextInput
        inputId="title"
        inputLabel="عنوان تنظیمات"
        inputPlaceholder="مسابقه آیلتس..."
        v-model="matchSettingPayload.title"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <TextInput
        inputId="totalMatchQuestionsCount"
        inputLabel="تعداد سوالات مسابقه"
        inputPlaceholder="5"
        v-model="matchSettingPayload.totalMatchQuestionsCount"
      ></TextInput>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      isOkButtonDisabled: false,
      matchSettingPayload: {
        title: null,
        totalMatchQuestionsCount: null,
        questionType: 1,
      },
    };
  },
  methods: {
    async sendCreateMatchSettingRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let createMatchSetting = new CreateMatchSetting(_this);
        createMatchSetting.setRequestParamDataObj(_this.matchSettingPayload);
        await createMatchSetting.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تنظیمات مسابقه با موفقیت ایجاد شد.",
              },
            });
            _this.matchSettingPayload = {
              totalMatchQuestionsCount: null,
              questionType: 1,
            };
            this.$bvModal.hide("create-match-setting-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomCreateDialog,
    TextInput,
    BCol,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import { CreateMatchSetting } from "@/libs/Api/Matches";
import { BCol } from "bootstrap-vue";
</script>
